import apiAxios from "helpers/apiAxios";

// Search user cho picker chọn Manager (mọi user, không cần admin).
export const searchManagerUsers = (q) =>
  apiAxios.get("/erp/payment_requests/user_search", { params: { q } }).then((r) => r.data);
export const searchAccountants = (q) =>
  apiAxios.get('/erp/payment_requests/accountant_search', { params: { q } }).then((r) => r.data);
export const getFinanceOptions = () =>
  apiAxios.get('/erp/payment_requests/finance_options').then((r) => r.data);

// Phiếu tạm ứng (QF-02) đã duyệt — để QF-03 chọn quyết toán.
export const getAdvances = () =>
  apiAxios.get("/erp/payment_requests/advances").then((r) => r.data);
